import { cn } from "@/utils/cn";
import { Icon } from "@/components/Icon/Icon";
import type { IconName } from "@/utils/types/ui";

type PathCardProps = {
  active: boolean;
  primary?: boolean;
  icon: IconName;
  title: string;
  desc: string;
  onClick: () => void;
};

export function PathCard({
  active,
  primary,
  icon,
  title,
  desc,
  onClick,
}: PathCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn("path-card", primary && "primary", active && "active")}
    >
      <div className="path-card-icon">
        <Icon name={icon} size={20} />
      </div>
      <div className="path-card-title">{title}</div>
      <div className="path-card-desc">{desc}</div>
    </button>
  );
}
